module.exports = {
          srcSet: __webpack_public_path__ + "85f8d65dab3683292785113a1003a439-99.png"+" 99w",
          images:[ {path: __webpack_public_path__ + "85f8d65dab3683292785113a1003a439-99.png",width: 99,height: 66}],
          src: __webpack_public_path__ + "85f8d65dab3683292785113a1003a439-99.png",
          toString:function(){return __webpack_public_path__ + "85f8d65dab3683292785113a1003a439-99.png"},
          
          width: 99,
          height: 66
        }